/*
  Product card row alignment
  --------------------------
  Cards in a row rarely carry the same content: one has a rating, another does not;
  one title wraps to two lines, another to one. Left alone, every element below the
  difference slides out of line.

  This measures the cards that actually share a visual row — grid, flex row, or slider
  track alike — and pads each slot to the tallest in that row. Titles then sit on one
  line, prices on another, and a card with no reviews keeps the gap instead of pulling
  everything up. Cards on the next row are measured separately, so a long title in row
  two never stretches row one.

  Slots are marked in the Liquid with data-pc-slot="title | rating | price | swatches |
  form | …". Any slot name works; they are grouped by name. Wrappers are rendered even
  when empty, which is what lets a card with no rating hold the space.
*/
(function () {
  var ENABLED = document.documentElement.getAttribute('data-card-align') !== 'off';
  if (!ENABLED) return;

  var SLOT = '[data-pc-slot]';
  var CARD = 'product-card, .product-card, [data-product-card], .sbc-card, .cyob-card, .kb-card, .fbt-item';
  var scheduled = false;

  function cards(scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(CARD));
  }

  /* Same container and same top edge = same visual row. Rounding absorbs sub-pixel
     drift from transforms and zoom. */
  function rowKey(card) {
    var r = card.getBoundingClientRect();
    var parent = card.parentNode;
    var pi = parent && parent.parentNode ? Array.prototype.indexOf.call(parent.parentNode.children, parent) : 0;
    void pi;
    return (card.offsetParent ? card.offsetParent.id || '' : '') + '|' + Math.round((r.top + window.pageYOffset) / 2) * 2;
  }

  function measure() {
    scheduled = false;
    var all = cards();
    if (!all.length) return;

    /* Clear previous padding before measuring, or heights only ever grow. */
    all.forEach(function (card) {
      card.querySelectorAll(SLOT).forEach(function (el) { el.style.minHeight = ''; });
    });

    /* Group by container first so unrelated lists never influence each other. */
    var byContainer = new Map();
    all.forEach(function (card) {
      var c = card.closest('.row, .swiper-wrapper, .cpm-cards-track, ul, [data-card-list]') || card.parentNode;
      if (!byContainer.has(c)) byContainer.set(c, []);
      byContainer.get(c).push(card);
    });

    byContainer.forEach(function (list) {
      var rows = new Map();
      list.forEach(function (card) {
        var k = rowKey(card);
        if (!rows.has(k)) rows.set(k, []);
        rows.get(k).push(card);
      });

      rows.forEach(function (rowCards) {
        if (rowCards.length < 2) return;
        var tallest = {};
        rowCards.forEach(function (card) {
          card.querySelectorAll(SLOT).forEach(function (el) {
            var name = el.getAttribute('data-pc-slot');
            var h = el.getBoundingClientRect().height;
            if (!tallest[name] || h > tallest[name]) tallest[name] = h;
          });
        });
        rowCards.forEach(function (card) {
          var seen = {};
          card.querySelectorAll(SLOT).forEach(function (el) {
            var name = el.getAttribute('data-pc-slot');
            if (seen[name]) return;
            seen[name] = true;
            var target = tallest[name];
            if (target > 0) el.style.minHeight = Math.ceil(target) + 'px';
          });
        });
      });
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(measure);
  }

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  /* Web fonts change text height after first paint. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  /* Judge.me badges, quick-view, filters, infinite scroll and sliders all mutate cards
     after load; re-measure when the DOM settles rather than guessing at timings. */
  if ('MutationObserver' in window) {
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(schedule, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
  /* Images arriving late change card height. */
  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG') schedule();
  }, true);

  window.themeAlignProductCards = schedule;
  schedule();
})();
